<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template v-if="row.checkStatus==2" slot-scope="{ row, index }" slot="action">
					<Button type="warning" size="small" style="margin-right: 5px" @click="denyCheck(row.checkId)">拒绝</Button>
					<Button type="success" size="small" style="margin-right: 5px" @click="passCheck(row.checkId)">通过</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="deneyShow" title="审核拒绝" width="300">
			<Input type="textarea" v-model="denyCheckData.checkRemark" maxlength="255" placeholder="请输入拒绝原因"></Input>
			
			<div slot="footer">
				<Button type="primary" @click="denyCheckSure">确认</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryConditionSelfJob'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				deneyShow:false,
				denyCheckData:{
					
				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '审核ID',
						width: 200,
						key: 'checkId',
						align: 'center'
					},
					{
						title: '岗位ID',
						width: 200,
						key: 'id',
						align: 'center'
					},
					{
						title: '用户	ID',
						key: 'userId',
						align: 'center',
						width: 200,
					},
					{
						title: '用户	名',
						key: 'userName',
						align: 'center',
						width: 200,
					},{
						title: '手机号',
						key: 'phone',
						align: 'center',
						width: 200,
					},{
						title: '城市',
						key: 'city',
						align: 'center',
						width: 200,
					},{
						title: '区域',
						key: 'area',
						align: 'center',
						width: 200,
					}, {
						title: '工作场景',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.scene;
							if (val == 1) {
								name = '线上'
							} else if (val == 2) {
								name = '线下'
							}else{
								name = '不限'
							}
							return h('span', name)
						}
					},
					{
						title: '职位类型',
						key: 'jobCategory',
						align: 'center',
						width: 250,
					},
					{
						title: '职位名称',
						key: 'title',
						align: 'center',
						width: 150,
					},
					{
						title: '企业名称',
						key: 'company',
						align: 'center',
						width: 200,
					},{
						title: '二维码',
						key: 'codeUrl',
						align: 'center',
						width: 200,
					}, {
						title: '提交时间',
						key: 'createTime',
						align: 'center',
						width: 200,
					}, {
						title: '审核时间',
						key: 'checkTime',
						align: 'center',
						width: 200,
					}, {
						title: '原因提示',
						key: 'checkRemark',
						align: 'center',
						width: 200,
					}, {
						title: '岗位状态',
						align: 'center',
						width: 150,
						render: (h, params) => {
							let name;
							let val = params.row.checkStatus;
							if (val == 0) {
								name = '待支付'
							} else if (val == 1) {
								name = '待发布'
							}else if (val == 2) {
								name = '待审核'
							}else if (val == 3) {
								name = '未通过审核'
							}else if (val == 4) {
								name = '已通过审核'
							}else{
								name = '已下线'
							}
							return h('span', name)
						}
					}, {
						title: '操作',
						slot: 'action',
						width: 200,
						align: 'center'
					}
				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.selfUnCheckJobPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.total || 0
						that.queryData = result.data
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			//审核
			passCheck(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '您已确认【审核通过】数据吗？',
					onOk: function() {
						api.statistics
							.selfJobCheck({
								checkId: id,
								checkResult: 1
							})
							.then(res => {
								const result = res.data || {}
								that.totalRecord = result.totalRecordNum || 0
								that.queryData = result.records
								that.refreshData()
							})
							.then(() => {
								that.$Message.success('Success!');
							})
					}
				})

			},
			denyCheck(id) {
				this.deneyShow=true,
				this.denyCheckData={
					checkId:id,
					checkResult:2,
					checkRemark:''
				}
			},
			denyCheckSure(){
				const that=this
				api.statistics
					.selfJobCheck(this.denyCheckData)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
						that.refreshData()
					})
					.then(() => {
						that.deneyShow=false
						that.$Message.success('Success!');
					})
			}
		
		},
		

	}
</script>